<template>
    <div class="skilllist">
      <router-link to="vlogskill">
        <div class="item">
          <img src="../img/skilllist_1.png" alt="">
          <div class="title">
            短视频拍摄技巧
          </div>
        </div>
      </router-link>
      <router-link to="makevlogskill">
        <div class="item">
          <img src="../img/skilllist_2.png" alt="">
          <div class="title">
            短视频制作技巧
          </div>
        </div>
      </router-link>
      <router-link to="plogskill">
        <div class="item">
          <img src="../img/skilllist_3.png" alt="">
          <div class="title">
            图片拍摄技巧
          </div>
        </div>
      </router-link>
      <router-link to="makeplogskill">
        <div class="item">
          <img src="../img/skilllist_4.png" alt="">
          <div class="title">
            图片制作技巧
          </div>
        </div>
      </router-link>
    </div>
</template>

<script>
export default {
    name: 'skilllist',
    data: function () {
        return {
            
        }
    },
    methods: {
      routerTo(path) {
        this.$router.push(path)
      }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.skilllist {
    width: 1200px;
    margin: 50px auto 50px;
    text-align: center;
    font-size: 20px;
    text-align: left;
    .item {
      display: inline-block;
      width: 290px;
      margin: 0 6px;
      &:last-child {
        margin-right: 0;
      }
      &:hover {
        .title {
          color: #000;
        }
      }
      .title {
        text-align: center;
        font-size: 24px;
        margin-top: 15px;
        color: #282828;
      }
    }
}
</style>
